import {createFundamentalType, registerFundamentalNode} from "#template/fundamental/factory"
import {MeshInfo} from "#template/interface-descriptors"
import {ObjectFT} from "#template/nodes/object/fundamental"
import {meshMarker} from "#template/nodes/object/mesh/marker"

export {isMeshLikeNode, isMeshLikeNodeClass, meshLike, meshLikeMarker} from "#template/nodes/object/mesh/marker"
export type {MeshLikeNode} from "#template/nodes/object/mesh/marker"

export const MeshFT = createFundamentalType({
    name: "Mesh",
    marker: meshMarker,
    parent: ObjectFT,
    InfoClass: MeshInfo,
    icon: "far fa-cube",
})

@registerFundamentalNode(MeshFT, "Likes")
export class MeshLikes extends MeshFT.Likes {}

@registerFundamentalNode(MeshFT, "Switch")
export class MeshSwitch extends MeshFT.Switch {}

@registerFundamentalNode(MeshFT, "Input")
export class MeshInput extends MeshFT.Input {}

@registerFundamentalNode(MeshFT, "Output")
export class MeshOutput extends MeshFT.Output {}

@registerFundamentalNode(MeshFT, "Export")
export class MeshExport extends MeshFT.Export {}
